// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assign-withdraw[data-v-0e126af3] {\n  display: block;\n  width: 100%;\n  padding: 20px 30px;\n}\n", ""]);
// Exports
module.exports = exports;
